module.exports = new __parcel__URL__("shop_animated_408_image.75f239e0.png").toString();